<template>
  <div class="container-fluid">
        <div class="card card-default">
          <div class="card-header feature-header">
            <div class="row">
              <div class="col-auto me-auto">
                <CardTitleComponent />
              </div>
              <div class="col-auto">
                <SearchComponent v-model="searchText" @search="onSearch" @clear="clearSearch" />
              </div>
              <div class="col-auto">
                <a class="btn btn-outline-primary btn-sm" @click="openModal()">
                  <i class="fas fa-plus"></i>&nbsp; {{ $t("addNew") }}
                </a>
              </div>
            </div>
          </div>
          <div class="card-body card-body-custom-layout">
            <div class="card-body-grid">
                <ejs-grid
                  ref="companyGrid"
                  :dataSource="gridData"
                  :allowPaging="true"
                  :allowResizing="true"  
                  :allowScrolling="true"          
                  :pageSettings="pageSettings"
                  :locale="locale"
                  :rowHeight="30"
                  height="100%"
                  :allowSorting="true"          
                  :searchSettings="searchOptions"
                  :commandClick="commandClick"
                >
                  <e-columns>
                    <e-column :headerText="$t('Legal Entity')" field="legalEntityName" width="150" freeze="Left"></e-column>                             
                    <e-column  field="id" :visible="false"></e-column>
                    <e-column
                      :headerText="$t('applicationKey')"
                      field="applicationKey" :valueAccessor="(record:string) => { return '*******' ; }"
                    ></e-column>
                    <e-column
                      :headerText="$t('clientKey')"
                      field="clientKey" :valueAccessor="(record:string) => { return '*******' ; }"
                    ></e-column>
                    <e-column
                      :headerText="$t('subscriptionKey')"
                      field="subscriptionKey" :valueAccessor="(record:string) => { return '*******' ; }"
                    ></e-column>
                    <e-column
                      field="shouldSync"
                      :headerText="$t('enableSyncing')"
                      :template="'columnTemplate'" width="150"
                    ></e-column>
                    <e-column
                      :headerText="$t('actions')"
                      textAlign="Center"
                      :template="'actionTemplate'"
                      freeze="Right" 
                      width="100" 
                    >
                      <template v-slot:actionTemplate="{ data }">
                        <div class="actions-row">
                          <a
                            href="javascript:void(0)"
                            class="ms-2 action-link action-edit"
                            title="Edit"
                            @click="commandClick({ commandColumn: { type: 'Edit' }, rowData: data })"
                          >
                            <i class="e-edit e-icons"></i>
                          </a>        
                        </div>
                      </template>
                    </e-column>
                  </e-columns>
                  <template v-slot:columnTemplate="{ data }">
                    <span
                      :class="
                        data.shouldSync
                          ? 'badge badge-success'
                          : 'badge badge-danger'
                      "
                    >
                      {{ data.shouldSync ? $t("active") : $t("inactive") }}
                    </span>
                  </template>
                </ejs-grid>
              </div>
            </div>
          </div>
        </div>

  <div class="modal fade" id="PageModal" Page="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ $t("company") }}</h4>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="closeModal()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form @submit="upsertCompany">
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6 form-group">
                  <label class="form-label">{{ $t("legalEntity") }} <span class="text-danger">*</span></label>
                  <ejs-dropdownlist id="legalEntityDropDown" ref="legalEntityDropDown" :dataSource="legalEntityOptions"
                      :fields="{ text: 'name', value: 'id' }" v-model="form.legalEntityId" 
                      :placeholder="$t('legalEntity')" popupWidth="auto" :showClearButton="true">
                  </ejs-dropdownlist>
              </div> 

              <div class="col-md-6 form-group">     
                  <label class="form-label"
                    >{{ $t("applicationKey") }}
                    <span class="text-danger">*</span></label
                  >
                    <div class="password-input-wrapper">
                        <input
                            :type="showApplicationKey ? 'text' : 'password'"
                            class="form-control input-sm password-input"
                            v-model="form.applicationKey"
                            required
                        />
                        <i
                            :class="showApplicationKey ? 'fas fa-eye-slash' : 'fas fa-eye'"
                            class="toggle-icon password-toggle-btn"
                            @click="showApplicationKey = !showApplicationKey"
                        ></i>
                    </div>     
              </div>

              <div class="col-md-6 mt-2 form-group">   
                  <label class="form-label"
                    >{{ $t("clientKey") }}
                    <span class="text-danger">*</span></label
                  >
                  <div class="password-input-wrapper">
                        <input
                            :type="showClientKey ? 'text' : 'password'"
                            class="form-control input-sm password-input"
                            v-model="form.clientKey"
                            required
                        />
                        <i
                            :class="showClientKey ? 'fas fa-eye-slash' : 'fas fa-eye'"
                            class="toggle-icon password-toggle-btn"
                            @click="showClientKey = !showClientKey"
                        ></i>
                    </div>            
              </div>

              <div class="col-md-6 mt-2 form-group">
                  <label class="form-label"
                    >{{ $t("subscriptionKey") }}
                    <span class="text-danger">*</span></label
                  >
                  <div class="password-input-wrapper">
                        <input
                            :type="showSubscriptionKey ? 'text' : 'password'"
                            class="form-control input-sm password-input"
                            v-model="form.subscriptionKey"
                            required
                        />
                        <i
                            :class="showSubscriptionKey ? 'fas fa-eye-slash' : 'fas fa-eye'"
                            class="toggle-icon password-toggle-btn"
                            @click="showSubscriptionKey = !showSubscriptionKey"
                        ></i>
                    </div>
              </div>
 
              <div class="col-md-6 form-group">
                      <div class="icheck-success">
                          <input type="checkbox" class="form-check-input me-1" id="shouldSync" v-model="form.shouldSync" />
                          <label class="form-label" for="shouldSync">
                              {{ $t("enableSyncing") }}
                          </label>
                      </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-sm btn-outline-close"
              @click="closeModal()"
            >
              <i class="fas fa-times"></i> {{ $t("close") }}
            </button>
            <button type="submit" class="btn btn-sm btn-outline-info-reverse">
              <i class="fas fa-save"></i>&nbsp;
              {{ isUpdate ? $t("update") : $t("save") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="modal fade" id="force-sync-modal" role="dialog">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Request Sync</h4>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="closeForceSyncModal"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-row">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                v-model="forceSync.type"
                value="full"
                id="syncRadio1"
              />
              <label class="form-check-label" for="syncRadio1">
                Full Sync
              </label>
            </div>
          </div>
          <div class="form-row">
            <div class="form-check">
              <input
                class="form-check-input"
                type="radio"
                v-model="forceSync.type"
                value="custom"
                id="syncRadio2"
              />
              <label class="form-check-label" for="syncRadio2">
                Custom Sync
              </label>
            </div>
          </div>
        </div>
        <div v-show="forceSync.type == 'custom'" class="modal-body">
          <div class="form-row">
            <div class="col">
              <div class="form-group">
                <label>Date: <span class="text-danger">*</span></label>
                <DatePickerComponent
                  v-model="forceSync.date"
                  :format="forceSync.format"
                  :max="forceSync.today"
                  placeholder="Select a date to sync from"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-sm btn-outline-danger"
            @click="closeForceSyncModal"
          >
            <i class="fas fa-times"></i>&nbsp; {{ $t("close") }}
          </button>

          <button
            v-on:click="forceSyncByDate()"
            :disabled="forceSync.type == 'custom' && !forceSync.date"
            type="button"
            class="btn btn-sm btn-outline-info"
          >
            <i class="fas fa-save"></i>&nbsp; Request Sync
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" src="../Company/Company.Service.ts">
import './CompanyComponent.css';</script>
